var raf = function raf(callback) {
  return +setTimeout(callback, 16);
};

var caf = function caf(num) {
  return clearTimeout(num);
};

if (typeof window !== 'undefined' && 'requestAnimationFrame' in window) {
  raf = function raf(callback) {
    return window.requestAnimationFrame(callback);
  };

  caf = function caf(handle) {
    return window.cancelAnimationFrame(handle);
  };
}

export default function wrapperRaf(callback) {
  return raf(callback);
}
wrapperRaf.cancel = caf;


//////////////////
// WEBPACK FOOTER
// ./node_modules/rc-util/es/raf.js
// module id = 90
// module chunks = 0